import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("workGroups")
export class WorkGroup extends BaseEntity {
  groupName: string;
}
